import React from 'react'

import "./css/orderConfirmation.css";

export  function OrderConfirmation() {
  return (
    <div className='orderConfirmation'>
       <h1>Congratulations!!</h1> 
       <h1>Order Placed Succesfully</h1>
       
    </div>
  )
}
